// **************************
// *** AgendamentosExcluidos pc_pendentes.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 16/10/24 | 15:08h
// **************************



import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
// import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import handleApiError from "../../../../Services/apiErrorHandler.js";

import PCMenu from "../../Components/Menu/pc_menu.jsx";
import { AutoLogout } from "../../../../Services/autologout.js";
import CardAgendamentos from '../../../AgendexPrestador/Components/Agendamentos/p_agendamentos.jsx';
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";

import './pc_agendamentos.css';

import { pc_getUserData } from "../../Services/pc_userutils.js";

function PCAgendamentosPendentes() {
    const tokenASW = localStorage.getItem("tokenasw");
    const tokenlg = localStorage.getItem("tokenlg");
    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, [tokenASW, tokenlg]);

    const initialUserData = pc_getUserData();
    const tipoAtendimento = 1;
    const [id_usuario, setId_usuario] = useState(initialUserData.userId); // id_usuario logado 23/9/24w
    const [id_colaborador, setId_colaborador] = useState(initialUserData.colaboradorId); // id_usuario logado 23/9/24w
    const [tamanho_pagina, setTamanho_pagina] = useState(initialUserData.TAMANHO_PAGINA); // id_usuario logado 23/9/24w
    const [nenhumAgendamentoEncontrado, setNenhumAgendamentoEncontrado] = useState(false);

    // const [nenhumAgendamentoPendenteEncontrado, setNenhumAgendamentoPendenteEncontrado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const MySwal = withReactContent(Swal);

    const [todosStatus, setTodosStatus] = useState([]);
    const [status, setStatus] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [nenhumStatusEncontrado, setNenhumStatusEncontrado] = useState(false);
    
    useEffect(() => {
        atualizarAgendamentosColaborador(id_colaborador, pagina);
    }, [id_colaborador, pagina]);

    // tipoAtendimento === 1 (busca agendamentos dos colaboradores) 23/9/24w
    const atualizarAgendamentosColaborador = async (id_colaborador, pagina) => {
        // console.log('atualizando após exclusão / id_col , pag', id_colaborador, pagina);
        setLoading(true);
        setAgendamentos([]);
        const url = `reserva/listarColaboradorWeb?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}&id_status1=7&token=${tokenASW}&id_colaborador=${id_colaborador}`;
        try {
            const response = await apiaxios.get(url);
            // setLoading(false);

            if (response.data.retorno) {
                Swal.fire('Erro', 'Erro ao carregar agendamentos: ' + response.data.retorno, 'error');
            } else {
                if (response.data.length === 0) {
                    setNenhumAgendamentoEncontrado(true);
                    MySwal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                        icon: 'info',
                        title: 'Nenhum agendamento pendente, encontrado neste momento...'
                    });
                    setHasMore(false);
                } else {
                    setNenhumAgendamentoEncontrado(false);
                    // console.log(`response data ao trocar colaborador: ${id_colaborador} `, response.data);
                    setAgendamentos(prevDados => [...prevDados, ...response.data]);
                    if (response.data.length < tamanho_pagina) {
                        setHasMore(false);
                    }
                }
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleMudarStatus = async (agendamento) => {
        const { ID_RESERVA } = agendamento;
    
        // console.log("array todosStatus ", todosStatus);
        try {
            let selectedStatus = 7;
    
            MySwal.fire({
                title: 'Selecione o novo Status:',
                html: `
                    <div id="statusSelect">
                        <select id="statusDropdown" class="swal2-select">
                            ${todosStatus
                                .filter(status => ![1, 3, 4, 6, 8, 9].includes(status.STA_ID)) // Filtra os status indesejados
                                .map(status => `
                                    <option value="${status.STA_ID}" ${status.STA_ID === 7 ? 'selected' : ''}>
                                        ${status.STA_DESCRICAO}
                                    </option>`)
                                .join('')}
                        </select>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: 'Alterar Status',
                cancelButtonText: 'Voltar',
                preConfirm: () => {
                    const selectedValue = document.getElementById('statusDropdown').value;
                    if (!selectedValue) {
                        Swal.showValidationMessage('Por favor, selecione um status.');
                        return false;
                    }
                    return selectedValue;
                }
            }).then(async (result) => {
                if (result.isConfirmed) {
                    selectedStatus = result.value;
    
                    // Faça a requisição para atualizar o status
                    const response = await apiaxios.put(`/reserva/StatusWeb`, {
                        id_status: selectedStatus,
                        id_reserva: ID_RESERVA,
                        tipoAtendimento,
                        cod_notificacao: 24
                    },
                    {
                        params: {
                            id_usuario,
                            token: tokenASW
                        }
                    });

                    if (response.status === 200 && response.data.retorno === "OK") {
                        Swal.fire('Sucesso', 'Status alterado com sucesso!', 'success');
                        // Atualize a UI se necessário
                    } else {
                        Swal.fire('Erro', response.data.retorno || 'Erro ao mudar o Status', 'error');
                    }
                }
            });
        } catch (error) {
            Swal.fire('Erro', 'Erro ao mudar o status: ' + error, 'error');
        }
    };

    useEffect(() => {
        const loadStatus = async () => {
            try {
                const retornoTodosStatus = await fetchStatus();
                setTodosStatus(retornoTodosStatus);
            } catch (error) {
                console.error('Erro ao buscar os status: ', error);
            }
        };
        loadStatus();
    },[]);

    const fetchStatus = async () => {
        try {
            setLoading(true);
            // console.log('dentro de try fetchStatus');
            const statusResponse = await apiaxios.get(`reserva/StatusListarWeb?id_usuario=${id_usuario}&token=${tokenASW}`);

            if (statusResponse.status === 200 && statusResponse.data.length > 0) {
                return statusResponse.data;
            } else {
                setNenhumStatusEncontrado(true);
                return [];
            }
        } catch (error) {
            console.error('erro: ', error);
            handleApiError(error);
            return [];
        } finally {
            setLoading(false);
        }
    };    
    

        

    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <PCMenu page="agendamentospendentes" />
                        </div>
                        <div className="col py-2 me-3">
                            <div className="form-group">
                                <h1 className="text-center">Agendamentos Pendentes / Colaborador</h1>
                                <hr />

                                <div className="row">
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                    {nenhumAgendamentoEncontrado ? (
                                        <div className="alert alert-danger mt-10" role="alert">
                                            Nenhum "Agendamento Pendente" disponível neste momento...
                                        </div>
                                    ) : (
                                        <div className="box-agendamentos">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Id.Reserva</th>
                                                        <th>Descrição</th>
                                                        <th>Nome Cliente</th>
                                                        <th>Fone Cliente</th>
                                                        <th>Data</th>
                                                        <th>Hora</th>
                                                        <th>Valor</th>
                                                        <th>Desconto</th>
                                                        <th>Valor Total</th>
                                                        <th>Nome Colaborador</th>
                                                        <th className="text-right">Status</th>
                                                        <th className="text-right">Ações</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {agendamentos.map((agendamento, index) => (
                                                        <CardAgendamentos
                                                            key={`${agendamento.ID_RESERVA}-${index}`}
                                                            agendamento={{
                                                                agendamento_id: agendamento.ID_RESERVA,
                                                                agendamento_descricao: agendamento.DESCRICAO || 'Descrição indisponível',
                                                                agendamento_nome: agendamento.AA_CLIENTE_NOME || 'Nome indisponível',
                                                                agendamento_fone: agendamento.AA_CLIENTE_FONE || 'Telefone indisponível',
                                                                agendamento_data: agendamento.DATA_RESERVA || 'Data indisponível',
                                                                agendamento_hora: agendamento.HORA || 'Hora indisponível',
                                                                agendamento_vr: agendamento.VALOR || 'Vr indisponível',
                                                                agendamento_desc: agendamento.DESCONTO || 'R$ 0,00',
                                                                agendamento_vrtot: agendamento.VALORTOTAL || 'Vr Tot indisponível',
                                                                agendamento_nome_colaborador: agendamento.COL_NOME || 'Colaborador indisponível',
                                                                agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO || 'Status indisponível'}`
                                                            }}
                                                            showExcluir={false}
                                                            showAvaliar={false}
                                                            showMotivo={false}
                                                            showMudarStatus={true}
                                                            handleMudarStatus={() => handleMudarStatus(agendamento)}
                                                            tipoAtendimento={tipoAtendimento}
                                                        />
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                                {hasMore && (
                                    <div className="load-more">
                                        <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default PCAgendamentosPendentes;